import script from "./EnvioFormComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnvioFormComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EnvioFormComponent.vue?vue&type=style&index=0&id=30454fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30454fd6"]])

export default __exports__